import React from 'react'
import Img from 'gatsby-image'

import MainSectionLayout from '@/main-section-layout'
import GetStartedButton from '@/get-started-button'
import PageTopBar from '@/page-top-bar'
import LargeText from '@/large-text'

import './styles.css'

const SectionWhatWeDo = ({ gray, data }) => {
  return (
    <PageTopBar iconName="laptop" text="What we do">
      <MainSectionLayout
        noLogo
        title="What we do"
        about="We bring beauty pageants to the next level with cutting-edge digital tools"
      >
        <Img sizes={data.whatWeDoMain.sizes} alt="" className="db mw500 center mb6" />

        <div className="mw800 center mb6">
          <LargeText>
            The Next Miss app provides the perfect environment for beauty fans to enjoy your content.
          </LargeText>
          <LargeText>
            We help our clients to be highly effective in running their beauty pageants; <br/>
            to embrace change with confidence; and to support them engage
            more with their audience, ready to take on the next challenge.
          </LargeText>
        </div>

        <GetStartedButton />
      </MainSectionLayout>
    </PageTopBar>
  )
}

export default SectionWhatWeDo



// WEBPACK FOOTER //
// ./src/components/section-what-we-do/section-what-we-do.js